<div class="component-container" data-cy="form" data-variant="variant1">
  @let check =
    dataService.environment().hasCampaignBis &&
    dataService.hasCurrentBisCampaign();

  @let bisConfig = config().header.bisBannerConfig;
  @if (check) {
    <div
      class="current-bis-banner"
      [style.backgroundColor]="bisConfig.backgroundColor"
    >
      @if (device() === DeviceType.DESKTOP) {
        <p
          class="new-badge"
          [style]="{
            backgroundColor: bisConfig.newBadge.backgroundColor,
            color: bisConfig.newBadge.color,
            fontFamily: bisConfig.newBadge.fontFamily,
          }"
        >
          {{ bisConfig.newBadge.label }}
        </p>
      }

      <img
        class="current-bis-logo"
        [src]="bisConfig.logo.imageUrl"
        [alt]="bisConfig.logo.alternativeText"
      />

      <div class="right-side">
        @if (device() !== DeviceType.DESKTOP) {
          <img
            [alt]="bisConfig.earnMoreLogoMobile.alternativeText"
            class="earn-more-logo"
            [src]="bisConfig.earnMoreLogoMobile.imageUrl"
          />
        } @else {
          <img
            [alt]="bisConfig.earnMoreLogoDesktop.alternativeText"
            class="earn-more-logo"
            [src]="bisConfig.earnMoreLogoDesktop.imageUrl"
          />
        }
      </div>
    </div>
  }

  <div role="main" class="header">
    @let bannerTop =
      device() === DeviceType.MOBILE
        ? config().header.mobileTopBackgroundImage
        : device() === DeviceType.TABLET
          ? config().header.tabletTopBackgroundImage
          : config().header.desktopBackgroundImage;

    <img [alt]="" class="banner-top" [src]="bannerTop" />

    <div class="header-wrapper">
      <div class="header-content">
        <div class="header-content_text">
          <p
            class="heading"
            [style.color]="config().header.title.color"
            [style.fontFamily]="config().header.title.fontFamily"
          >
            {{ config().header.title.label }}
          </p>
          <div class="club-icon-container">
            <p
              class="label"
              [style.color]="config().header.avec.color"
              [style.fontFamily]="config().header.avec.fontFamily"
            >
              {{ config().header.avec.label }}
            </p>

            <img
              class="club-logo"
              [src]="config().header.clubLogo.imageUrl"
              [alt]="config().header.clubLogo.alternativeText"
            />
          </div>

          <div class="reward-container">
            <img
              class="reward"
              [src]="config().header.reward.imageUrl"
              [alt]="config().header.reward.alternativeText"
            />
            @let additionalText = config().header.additionalText;
            <p
              class="fav-text"
              [style.color]="additionalText.color"
              [innerHTML]="additionalText.text[device()]"
              [style.fontFamily]="additionalText.fontFamily"
            ></p>
          </div>
        </div>
      </div>
      <div class="form-container" role="form">
        @let bannerBottom =
          device() === DeviceType.MOBILE
            ? config().header.mobileBottomBackgroundImage
            : device() === DeviceType.TABLET
              ? config().header.tabletBottomBackgroundImage
              : '';

        @if (device() !== DeviceType.DESKTOP) {
          <img [alt]="" class="banner-bottom" [src]="bannerBottom" />
        }
        @let formConfig = config().header.formWrapper;
        <div class="form-wrapper">
          <div
            class="form-wrapper_content"
            [style.backgroundColor]="formConfig.backgroundColor"
          >
            @if (showErrorMessage()) {
              <div class="error" data-cy="login_error">
                {{ formConfig.errorMessage }}
              </div>
            }

            <div class="form">
              <h4
                class="title"
                [style.color]="formConfig.title.color"
                [style.fontFamily]="formConfig.title.fontFamily"
              >
                {{ formConfig.title.label }}
              </h4>
              <form [formGroup]="authForm">
                @for (
                  item of formConfig.form.fields;
                  track item.formControlName
                ) {
                  @switch (item.type) {
                    @case (
                      FormFieldType.TEXT ||
                      FormFieldType.NUMBER ||
                      FormFieldType.EMAIL
                    ) {
                      <b2c-input
                        [type]="item.type"
                        [tooltip]="item.tooltip"
                        [label]="item.label || ''"
                        [labelGroup]="cardNumberLabel"
                        [placeholder]="item.placeholder"
                        [attr.data-cy]="item.formControlName"
                        [inputTypeGroup]="item.group || false"
                        [formControlName]="item.formControlName"
                        [errorMessages]="
                          controlErrorMessages[item.formControlName]
                        "
                      />
                    }
                    @case (FormFieldType.SELECT) {
                      <b2c-select
                        [label]="item.label || ''"
                        [options]="item.options || []"
                        [placeholder]="item.placeholder"
                        [attr.data-cy]="item.formControlName"
                        [formControlName]="item.formControlName"
                        (ngModelChange)="onCardTypeChanged($event)"
                        [errorMessages]="
                          controlErrorMessages[item.formControlName]
                        "
                      />
                    }
                    @default {
                      <b2c-input
                        [type]="item.type"
                        [tooltip]="item.tooltip"
                        [label]="item.label || ''"
                        [labelGroup]="cardNumberLabel"
                        [placeholder]="item.placeholder"
                        [attr.data-cy]="item.formControlName"
                        [inputTypeGroup]="item.group || false"
                        [formControlName]="item.formControlName"
                        [errorMessages]="
                          controlErrorMessages[item.formControlName]
                        "
                      />
                    }
                  }
                }

                <div class="tc-container">
                  <b2c-checkbox
                    [attr.data-cy]="
                      formConfig.form.additionalFields[0].formControlName
                    "
                    [formControlName]="
                      formConfig.form.additionalFields[0].formControlName
                    "
                    [label]="formConfig.form.additionalFields[0].placeholder"
                  />
                  <a
                    class="link"
                    [attr.aria-label]="formConfig.acceptModality.ariaLabel"
                    [title]="formConfig.acceptModality.ariaLabel"
                    [style]="{
                      color: formConfig.acceptModality.color,
                      fontFamily: formConfig.acceptModality.fontFamily,
                    }"
                    routerLink="{{ formConfig.acceptModality.url }}"
                    >{{ formConfig.acceptModality.label }}</a
                  >
                </div>
                <div class="cf-turnstile" #turnstileContainer></div>
                <div class="form-footer">
                  <b2c-button
                    class="submit-btn"
                    buttonType="submit"
                    data-cy="login_button"
                    (click)="submit()"
                    [disabled]="authForm.invalid || formSubmitted()"
                    [styles]="{
                      borderRadius: '100px',
                      color: formConfig.form.submitButton.color,
                      fontFamily: formConfig.form.submitButton.fontFamily,
                      borderColor: formConfig.form.submitButton.backgroundColor,
                      backgroundColor:
                        formConfig.form.submitButton.backgroundColor,
                    }"
                  >
                    <span
                      [innerHTML]="formConfig.form.submitButton.label | safe"
                    ></span>
                  </b2c-button>
                </div>
              </form>

              <a
                target="_blank"
                class="link-to-card"
                [href]="formConfig.linkToCard.url"
                [title]="formConfig.linkToCard.ariaLabel"
                [attr.aria-label]="formConfig.linkToCard.ariaLabel"
                [style]="{
                  color: formConfig.linkToCard.color,
                  fontFamily: formConfig.linkToCard.fontFamily,
                }"
              >
                @let iconConfig = formConfig.linkToCard.icon;
                @if (iconConfig) {
                  <img
                    [src]="iconConfig.imageUrl"
                    [alt]="iconConfig.alternativeText"
                  />
                }
                <p>{{ formConfig.linkToCard.label }}</p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  @if (
    config().howToPlay.specificDisplayCondition === DISPLAY_CONDITION.ALWAYS
  ) {
    <b2c-how-to-play
      [enableSwipe]="true"
      class="how-to-play"
      [config]="config().howToPlay"
    />
  }

  <b2c-template class="notes" [template]="config().notes" />

  <div class="cookies-settings-container">
    <div class="label">Paramétrez vos cookies ici :</div>

    <button id="ot-sdk-btn" class="ot-sdk-show-settings cookie-btn">
      Paramètres des cookies
    </button>

    <a routerLink="/cookie-policy" class="cookie-policy-link"
      >Politique des cookies</a
    >
  </div>

  <b2c-footer />
</div>
